import Advantages from '@/components/Advantages'
import Cases from '@/components/Cases'
import ContactForm from '@/components/ContactForm'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import Hero from '@/components/Hero'
import Services from '@/components/Services'
import WhatIsSection from '@/components/WhatIsSection'

function Home() {
  return (
    <div className="min-h-screen bg-neutral-950">
      <Header />
      <Hero />
      <WhatIsSection />
      <Services />
      <Advantages />
      <Cases />
      <ContactForm />
      <Footer />
    </div>
  )
}

export default Home
